import A from 'utils/metrics/analytic'
import { Key } from 'constants/search-data/courses-search-data'

enum originFilter {
  WEBINAR_LIST = 'webinar_list',
  LIBRARY = 'library',
  CLINICALCASE = 'clinical_list',
}
// Использование фильтров на страницах  ВЕБИНАРЫ / БИБИЛИОТЕКА / КЛИН КЕЙСЫ
const A_filterUsage = (origin: originFilter, key: string) => {
  if (key === Key.SPECIALITIES) A.setEvent('filter_usage', { origin, type: 'speciality' })
  if (key === Key.THEMES) A.setEvent('filter_usage', { origin, type: 'themes' })
  if (key === Key.LECTURS) A.setEvent('filter_usage', { origin, type: 'lectures' })
  if (key === Key.TEXT) A.setEvent('filter_usage', { origin, type: 'search' })
  if (key === Key.DATES) A.setEvent('filter_usage', { origin, type: 'dates' })
}

export { A_filterUsage, originFilter }
